import styled from 'styled-components';

export const Wrapper = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: '1fr',
  marginBottom: theme.spacing(5),
  '& > div:first-child': {
    marginBottom: theme.spacing(2.5)
  },

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: '1fr 1fr',

    '& > div:first-child': {
      marginRight: theme.spacing(2.5),
      marginBottom: 0
    },
    '& > div:nth-child(2)': {
      marginLeft: theme.spacing(2.5)
    }
  }
}));

export const BlockWrapper = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateRows: 'auto 1fr auto auto',

  [theme.breakpoints.up('sm')]: {
    gridTemplateRows: 'auto 1fr auto 1fr'
  }
}));
